module.exports = "/static/assets/cecb0f67f95793b26ddaea37e7ebc49a.png";